import React from 'react';

import { useUserInfo } from '../../../../hooks/useUserInfo';
import { LogoutButton } from '../../../Profile/LogoutButton/LogoutButtonV2';

export const Profile = () => {
  const { data: userInfo } = useUserInfo();
  return (
    <div className="flex flex-col h-full">
      <span>Profile</span>
      <div className="flex flex-col mt-f4">
        <div className="flex items-center justify-center h-f2 w-f2 bg-main text-negative">
          {userInfo?.firstName?.[0]?.toUpperCase() || 'U'}
        </div>
        <div className="flex flex-col mt-f2">
          <span>
            {userInfo?.firstName} {userInfo?.lastName}
          </span>
          <span className="text-main-500">{userInfo?.email}</span>
          <span className="text-main-500">
            Member of {userInfo?.workspaces?.length} Workspaces
          </span>
        </div>
      </div>
      <div className="mt-auto w-fit">
        <LogoutButton />
      </div>
    </div>
  );
};
